import axios from '../../config/axios';
import apiPaths from '../apiPaths';

const onGetInsuredRisksToPolicies = (params) => axios.get(apiPaths.insuredRisksToPoliciesBase, { params });

const onCreateInsuredRisksToPolicy = (insuredRisks) => axios.post(apiPaths.insuredRisksToPoliciesBase, insuredRisks);

const onUpdateInsuredRisksToPolicy = (insuredRisks) => axios.put(apiPaths.insuredRisksToPoliciesBase, insuredRisks);

const onDeleteInsuredRisksForPolicy = (insuredRisks) =>
  axios.post(`${apiPaths.insuredRisksToPoliciesBase}/delete-many`, insuredRisks);

const onGetInsuredRisksPairs = (insuredRisks, policy_id) =>
  axios.get(apiPaths.insuredRisksToPoliciesBase, {
    params: { insured_risk_id: insuredRisks, policy_id, paging: false }
  });

export {
  onGetInsuredRisksToPolicies,
  onCreateInsuredRisksToPolicy,
  onUpdateInsuredRisksToPolicy,
  onDeleteInsuredRisksForPolicy,
  onGetInsuredRisksPairs
};
